import React, { useContext } from 'react'

import Loader from '../components/loader'
import { AccountContext } from '../context/account'

interface Props {
  children: React.ReactNode
}

const ProtectedRoute = ({ children }: Props) => {
  const { account } = useContext(AccountContext)

  // Auth state not resolved yet — show loader (same as your original).
  if (!account.checked) {
    return <Loader center middle />
  }

  // if (!account.loggedIn) {
  //   return <Navigate to="/login" replace />
  // }

  return <>{children}</>
}

export default ProtectedRoute